<template>
  <div>
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-lg-12 pb-5 d-flex flex-column" v-if="!pageloader" > 
      <!-- default card when there's no intro video and company details -->
        <div class="col-12 card mb-4 introvideocard" v-if="savedIntroVideoLink === null && !companyDetails">
          <div class="row no-gutters p-2" >
            <div class="col p-5 text-center">
              <img src="../../assets/no_video.svg" alt="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
              <div class="col d-flex justify-content-center fontsize16 black60 proximanova">No Details Found</div>
            </div>
          </div>
        </div>
        <div class="card mb-4 introvideocard" v-else>
          <div class="p-3 ml-2" v-if="savedIntroVideoLink !== null">
            <span class="fontsize14 black stylebold">Intro Video</span>
          </div>
          <!-- intro video card -->
          <div class="card introvideocard" v-if="savedIntroVideoLink !== null">
            <div>
            <video height="320" oncontextmenu="return false" :src="savedIntroVideoLink"  @ended="onenddisplayreplayIcon()" @waiting="displayLoadingLogo()" @canplay="stopLoadingLogo()"  controlsList="nodownload"  id="introVideo" > </video>
          </div>
          <div class="card-img-overlay videocard">
            <div class="row no-gutters mb-3 ml-0 mr-0 companyvid_overlay1">
              <div class="black_overlay_height"></div>
            </div>
            <div class="mt-3">
              <img src="../../assets/play_video.svg" v-if="!playingIntroVideo" class="playpausevideobtn" alt="playvideo" @click="playIntroVideo">
              <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingIntroVideo && replayIntroVideo">
                <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo()">
              </div>
              <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingIntroVideo && loadingIntroVideo">
                <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
              </div>
              <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingIntroVideo && !replayIntroVideo && !loadingIntroVideo" alt="pausevideo" @click="playIntroVideo">
            </div>
            <div class="bottom">
              <div class="companyvid_overlay2">
                <div class="black_overlay_height"></div>
              </div>
            </div>
          </div>
          </div>
          <!-- company details section -->
          <div class="col-12 pt-3 pb-3 ">
            <div class="d-flex" v-if="savedIntroVideoLink !== null">
              <div class="mt-3 mb-3 ml-3 mr-auto">
                <label class="fontsize16 black stylebold proximanova">{{companyDetails.companyName}} - Introduction</label> <br>
                <span v-if="savedIntroVideoDescription" class="fontsize14 black60 proximanova text-capitalize">{{savedIntroVideoDescription}}</span>
              </div>
            </div>
            <div class="d-flex">
              <div class="mt-3 mb-3 ml-3 mr-auto">
                <label class="fontsize16 black60 stylebold proximanova">More Details</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex flex-column">
                <div class="d-flex mb-3">
                  <span class="fontsize14 black60 proximanova col-lg-4 col-6">Contact Number</span>
                  <span class="fontsize14 black proximanova" v-if="companyDetails.contactNumber">{{companyDetails.contactNumber}}</span>
                  <span class="fontsize14 black proximanova" v-else>--</span>
                </div>
                <div class="d-flex">
                  <span class="fontsize14 black60 proximanova col-lg-4 col-6">Company Size</span>
                  <p class="fontsize14 black proximanova" v-if="companyDetails.companySize">{{companyDetails.companySize}}</p>
                  <span class="fontsize14 black proximanova" v-else>--</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex flex-column ">
                <div class=" d-flex">
                  <span class="fontsize14 black60 proximanova col-lg-4 col-6">Industry</span>
                  <p class="fontsize14 black proximanova" v-if="companyDetails.industry">{{companyDetails.industry}}</p>
                  <span class="fontsize14 black proximanova" v-else>--</span>
                </div>
                <div class="d-flex">
                  <span class="fontsize14 black60 proximanova col-lg-4 col-6">Founded</span>
                  <p class="fontsize14 black proximanova" v-if="companyDetails.founded">{{companyDetails.founded}}</p>
                  <span class="fontsize14 black proximanova" v-else>--</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex flex-column ">
                <div class="d-flex">
                  <span class="fontsize14 black60 proximanova col-lg-4 col-6">Specialities</span>
                  <p class="fontsize14 black proximanova" v-if="companyDetails.specialities">{{companyDetails.specialities}}</p>
                  <span class="fontsize14 black proximanova" v-else>--</span>
                </div>
                <div class="d-flex">
                  <span class="fontsize14 black60 proximanova col-lg-4 col-6">Type</span>
                  <p class="fontsize14 black proximanova" v-if="companyDetails.type">{{companyDetails.type}}</p>
                  <span class="fontsize14 black proximanova" v-else>--</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex">
                <span class="fontsize14 black60 proximanova col-lg-4 col-6">Location</span>
                <p class="fontsize14 black proximanova" v-if="companyDetails.cityName">{{companyDetails.cityName}}, {{companyDetails.stateName}}, {{companyDetails.countryName}}</p>
                <span class="fontsize14 black proximanova" v-else>--</span>
              </div>
            </div>
            <!-- <div class="horizontalline mb-3"></div>
            <div class="d-flex">
              <div class="mt-1 mb-3 ml-3 mr-auto">
                <label class="fontsize14 black60 stylebold proximanova">Social Media</label>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 d-flex">
                <span class="fontsize14 black60 proximanova col-lg-4 col-6">Twitter URL</span>
                <a class="fontsize14 blue proximanova" v-if="companyDetails.twitterURL" :href="companyDetails.twitterURL" target="_blank">
                  <img src="../../assets/twitter.svg" class="img-fluid" alt="twitterimg">
                </a>
                <span class="fontsize14 black proximanova" v-else>--</span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 d-flex">
                <span class="fontsize14 black60 proximanova col-lg-4 col-6">Linked in URL</span>
                <a class="fontsize14 blue proximanova" v-if="companyDetails.linkedInURL" target="_blank" :href="companyDetails.linkedInURL">
                  <img src="../../assets/linkedin.svg" class="img-fluid" alt="linkedinimg">
                </a>
                <span class="fontsize14 black proximanova" v-else>--</span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 d-flex">
                <span class="fontsize14 black60 proximanova col-lg-4 col-6">Youtube URL</span>
                <a class="fontsize14 blue proximanova" v-if="companyDetails.youtubeURL" target="_blank" :href="companyDetails.youtubeURL">
                  <img src="../../assets/youtube.svg" class="img-fluid" alt="youtubeimg">
                </a>
                <span class="fontsize14 black proximanova" v-else>--</span>
              </div>
            </div> -->
          </div>
          </div>
    </div>
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import $ from 'jquery'
export default{
    data(){
        return{
          pageloader : true,
          addintrovideoimage : require('../../assets/Create_Video.svg'),
          playingIntroVideo : false,
          replayIntroVideo : false,
          loadingIntroVideo : false,
          savedIntroVideoId : null,
          savedIntroVideoLink : null,
          savedIntroVideoDate : null,
          savedIntroVideoDescription : null,
          //details section
          businessAccountId : null,
          companyprofileId : null,
          companyDetails : {}
        }
    },
    components: {
    },
    methods :{
      // get company data will loading the component
      getCompanyData() {
        httpuserprofile.get('/userprofile/getcompanyProfileData?businessAccountId='+this.businessAccountId)
        .then((response) => {
          this.pageloader = false;
          this.companyDetails = response.data;
          this.setTootlTip()
        }).catch((e) => {
          this.pageloader = false;
          console.log(e)
          this.setTootlTip()
        })
      },
      setTootlTip(){
        setTimeout(function() {
          $('[data-toggle="tooltip"]').tooltip();
        },2000);
      },
      //get intro video while loading the component
      getIntroVideo() {
        httpuserprofile.get('/userprofile/getCompanyVideosList?companyProfileId='+this.companyprofileId+'&businessAccountId='+this.businessAccountId+'&videoType=INTRO')
        .then((response) => {
          if(response.data.length > 0) {
            this.savedIntroVideoId = response.data[0].videoId;
            this.savedIntroVideoLink = response.data[0].videoLink;
            this.savedIntroVideoDescription = response.data[0].description;
            this.savedIntroVideoDate = response.data[0].creationD;
          }
        }).catch((e) => {
          console.log(e)
        })
      },
      /////////////////////////// intro video section ////////////////////////
      
      //play and pause for intro video
      playIntroVideo : function() {
        var video = document.getElementById('introVideo')
        if(!this.playingIntroVideo) {
          this.playingIntroVideo = true
          video.play()
        }else{
          this.playingIntroVideo = false;
          video.pause()
        }
      },
      onenddisplayreplayIcon() {
        this.replayIntroVideo = true;
        this.loadingIntroVideo = false;
      },
      displayLoadingLogo() {
        this.loadingIntroVideo = true;
      },
      stopLoadingLogo() {
        this.loadingIntroVideo = false;
      },
      replayVideo() {
        this.replayIntroVideo = false;
        this.loadingIntroVideo = false;
        this.playingIntroVideo = false;
        this.playIntroVideo()
      }
    },
    mounted(){
      $('[data-toggle="tooltip"]').tooltip();
      this.businessAccountId = this.$session.get("business_account_id")
      this.companyprofileId = this.$session.get("company_profile_id")
      this.getCompanyData()
      this.getIntroVideo()
    }
}
</script>
<style scoped>
/* video card styles */
.pausebtn{
  display: none;
}
.videocard:hover .pausebtn{
  display: block;
  margin-top: 7%;
}
.introvideocard{
  padding-left: 0;
  padding-right: 0;
  border-radius: 10px ;
}
.card-img-overlay{
  padding: 0;
}
.playpausevideobtn{
  margin-left: 46%;
  margin-top: 5%;
  cursor: pointer;
}
.pageloader{
  width: 10%;
  margin-left: 45%;
  margin-top: 5%;
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 35px !important;
  width: 150px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-70%, 10px, 10px) !important;
}
#introVideo{
  width: 100%;
}
#playvideobtn {
  /* display: none; */
  margin-left: 45%;
  margin-top: 7% !important;
  cursor: pointer;
}
.bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.closebtnmouseover{
  padding-left: 6px;
  padding-right: 2px;
  margin-top: -4px;
  border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtn {
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
a:hover{
  color: #007AFF !important;
}
@media screen and (min-width: 600px) {
  .no-video {
    width: 50%;
    align-self: center;
  }
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
}
</style>
